import { Record as record } from 'immutable';
import _ from 'lodash';

import trainTime from '../../lib/TrainTime';
import { resolve } from '../../helpers/LinkMapper';

const defaults = _.zipObject([
    'description',
    'transitMode',
    'dateTime',
    'type',
    'status'
]);

class KeyGoTap extends record(defaults) {

    static fromJSON (json = {}) {
        const data = {
            description: resolve(json.description).with(String),
            transitMode: resolve(json.transitMode).with(String),
            dateTime: resolve(json.dateTime).with(trainTime),
            type: resolve(json.type).with(String),
            status: resolve(json.status).with(String)
        };
        return new KeyGoTap(data);
    }

}

export default KeyGoTap;
